import {
  List,
  TextField,
  EditButton,
  ShowButton,
  SimpleList,
  Datagrid,
  BooleanField,
  NullableBooleanInput,
  DeleteButton,
  FunctionField,
  TopToolbar,
  CreateButton,
  useNotify,
  useRefresh,
} from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import ActivateButton from "server/components/ActivateButton";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { PreferencesExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";

const postFilters = [
  <NullableBooleanInput
    label="Активна"
    source="isActive"
    alwaysOn
    nullLabel="Всички"
  />,
  <NullableBooleanInput
    label="Заявява се при кандидатстване"
    source="isZvo"
    alwaysOn
    nullLabel="Всички"
    style={{ width: 300 }}
  />,
];

const ListPreferences = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();
  const notify = useNotify();
  const refresh = useRefresh();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={PreferencesExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Преференции"
      sx={settings.style.expandStyle}
      filters={postFilters}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreatePreferences)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow fields={[{ label: "Заявява се при кандидатстване", value: record.isZvo ? "Да" : "Не" }]} />
              <MobileListRow fields={[{ label: "Активна", value: record.isActive ? "Да" : "Не" }]} />
              {checkPermission(userPermissions, permissions.canDeletePreferences) && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {record.isActive ? (
                    <DeleteButton
                      record={record}
                      label="Деактивирай"
                      startIcon={<DoNotDisturbOnIcon />}
                      successMessage="Успешно деактивирахте статуса!"
                    />
                  ) : (
                    <ActivateButton />
                  )}
                </div>
              )}
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(userPermissions, permissions.canManagePreferences) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <BooleanField
            source="isZvo"
            label="Заявява се при кандидатстване"
            sortable={false}
          />
          <BooleanField
            source="isActive"
            label="Активна"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canManagePreferences) && <EditButton />}
          {checkPermission(userPermissions, permissions.canDeletePreferences) && (
            <FunctionField
              render={record =>
                record.isActive ? (
                  <DeleteButton
                    record={record}
                    label="Деактивирай"
                    startIcon={<DoNotDisturbOnIcon />}
                    successMessage="Успешно деактивирахте статуса!"
                  />
                ) : (
                  <ActivateButton />
                )
              }
            />
          )}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListPreferences;
